module.exports = __webpack_public_path__ + "img/ring_r_0_0_null@3x.4eea476d.png";